import { Box, Pagination, Typography, Skeleton } from "@mui/material";
import { colors } from "../../theme/palette";
import { UserInfo } from "../../types";
import UserItem, { UserLoadingItem } from "./UserItem";
import { useTranslation } from "react-i18next";

const SearchResult = ({
  isSearchDataLoading,
  paginationData,
  type,
  searchingList,
  page,
  handleChangePage,
}: {
  isSearchDataLoading: boolean;
  paginationData: any;
  type: string | null;
  searchingList: any;
  page: number;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "22px",
        }}
      >
        <Typography
          variant="body13Bold"
          sx={{
            fontWeight: 500,
            color: colors.Black100,
            display: "flex",
            alignItems: "center",
            columnGap: "8px",
          }}
        >
          {isSearchDataLoading ? (
            <Skeleton
              variant="rounded"
              animation="wave"
              sx={{
                width: "50px",
              }}
            />
          ) : (
            paginationData.totalItems
          )}

          {type === "users"
            ? ` ${t("pages.search.peopleRelated")}`
            : type === "entities"
            ? ` ${t("pages.search.entitiesRelated")}`
            : ""}
        </Typography>
      </Box>

      {isSearchDataLoading && (
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "20px" }}>
          {[...Array(14)].map((_, idx) => (
            <UserLoadingItem key={idx} isLast={idx === 13} />
          ))}
        </Box>
      )}

      {searchingList.length === 0 && !isSearchDataLoading && (
        <Typography
          variant="body16Regular"
          sx={{
            fontWeight: 500,
            color: colors.Black100,
          }}
        >
          {type === "users"
            ? t("pages.search.noTalents")
            : t("pages.search.noEntities")}
        </Typography>
      )}

      {searchingList.length > 0 && !isSearchDataLoading && (
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "20px" }}>
          {searchingList.map((user: UserInfo) => (
            <UserItem key={user.id} user={user} />
          ))}
        </Box>
      )}

      {!isSearchDataLoading && (
        <Pagination
          count={paginationData?.totalPages}
          page={
            !paginationData?.totalItems || paginationData?.totalItems <= 0
              ? 1
              : page + 1
          }
          onChange={handleChangePage}
          sx={{
            margin: "33px auto 0",
            direction: "ltr !important",
            "& .MuiPagination-ul": {
              justifyContent: "center",
            },
            "& .MuiButtonBase-root": {
              borderRadius: "8px !important",
            },
          }}
        />
      )}
    </>
  );
};

export default SearchResult;
